import { render } from "./EmptySearch.vue?vue&type=template&id=4523e882"
import script from "./EmptySearch.vue?vue&type=script&lang=js"
export * from "./EmptySearch.vue?vue&type=script&lang=js"

import "./EmptySearch.vue?vue&type=style&index=0&id=4523e882&lang=scss"
script.render = render

export default script